import type { FieldType } from '@platform/core/types';

/** Базові ширини колонок за типом поля (UIUX tables/table-view; BASE прототипу v4), px. */
const BASE: Partial<Record<FieldType, number>> = { text: 130, textarea: 160, number: 100, select: 140, date: 104, user: 160, tags: 160, area: 170, iteration: 170 };

/** Службові колонки таблиці записів, px: прапорець вибору 40, код 92, назва — від 220 (решта ширини таблиці). */
export const COLUMN_WIDTHS = { check: 40, code: 92, titleMin: 220 } as const;

/**
 * Ширина колонки поля в таблиці записів: max(база за типом (інакше 130), довжина підпису × 7.6 + 64) — заголовок вміщується без обрізання,
 * як у прототипі (MW). Чиста функція.
 */
export function columnMinWidth(type: FieldType, label: string): number {
  return Math.max(BASE[type] ?? 130, Math.ceil(label.length * 7.6) + 64);
}
